export default __webpack_public_path__ + "static/media/icon-alone.61bcf961.webp";